import {
  Directive,
  ElementRef,
  Host,
  HostListener,
  Input,
  Optional,
} from "@angular/core";
import { UntypedFormArray, UntypedFormGroup, NgForm } from "@angular/forms";

@Directive({
  selector: "[svMarkFormTouched], sv-button[svMarkFormTouched]",
})
export class MarkFormTouchedDirective {
  @Input() markOnClick: boolean = false;

  constructor(
    @Host() @Optional() private form: NgForm,
    private elementRef: ElementRef
  ) {
    if (form && !this.markOnClick) {
      const oldSubmit = form.onSubmit;

      form.onSubmit = function (): boolean {
        if (form.invalid) {
          const controls = form.controls;
          Object.keys(controls).forEach((controlName) =>
            controls[controlName].markAsTouched()
          );
          return false;
        }
        return oldSubmit.apply(form, arguments);
      };
    }
  }

  @HostListener("click")
  onSubmit() {
    if (!this.isDisabledOrLoading()) {
      this.markFormTouched();
    }
  }

  @HostListener("onClick")
  onCustomButtonClick() {
    if (!this.isDisabledOrLoading()) {
      this.markFormTouched();
    }
  }

  private isDisabledOrLoading(): boolean {
    const element = this.elementRef.nativeElement;
    // Check for native disabled attribute
    if (element.tagName?.toLowerCase() !== "button") {
      const findButton = element.querySelector("button");
      if (findButton) {
        return findButton.disabled || findButton.hasAttribute("disabled");
      }
    }

    if (element.disabled || element.hasAttribute("disabled")) {
      return true;
    }

    // Check for loading attribute/property on custom button
    if (
      element.loading ||
      element.hasAttribute("ng-reflect-loading") === "true"
    ) {
      return true;
    }

    return false;
  }

  private markFormTouched() {
    if (this.markOnClick && this.form) {
      const formGroup = this.form.form as UntypedFormGroup;

      formGroup.markAllAsTouched();
      this.markControlsDirty(formGroup);
    }
  }

  private markControlsDirty(group: UntypedFormGroup | UntypedFormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.controls[key];

      if (
        abstractControl instanceof UntypedFormGroup ||
        abstractControl instanceof UntypedFormArray
      ) {
        this.markControlsDirty(abstractControl);
      } else {
        abstractControl.markAsDirty();
        abstractControl.updateValueAndValidity();
      }
    });
  }
}
